import {useTranslation} from "react-i18next";
import {useMutation} from "react-query";
import {CORE_API_SUFFIX, dataFetch, DIGGER_API_SUFFIX} from "../../../axios/customAxios";
import {handleApiError} from "../../requestHelpers/requestHelpers";

export const sendGAcode = () => {
    const { t } = useTranslation();
    return useMutation(
        (object: any) => dataFetch.patch(
            `${CORE_API_SUFFIX}organization-settings`,
            {
                gaMeasurementId : object.gaMeasurementId,
                ga4Secret: object.ga4Secret,
            },
        ),
        {
            onError: (error: any) => {
                handleApiError(error, t);
            },
        },
    );
};

export const uninstallGA = () => {
    const { t } = useTranslation();
    return useMutation(
        () => dataFetch.patch(
            `${CORE_API_SUFFIX}organization-settings/google-analytics/uninstall`,
        ),
        {
            onError: (error: any) => {
                handleApiError(error, t);
            },
        },
    );
};